<template>
    <div id="wati-div">
    </div>
</template>

<script>
import iframeUtil from '../../services/iframeUtil';

export default {
    name: 'WatiWidget',

    mounted() {
        // Check if the component is not inside an iframe
        if(iframeUtil.isIframe() === false) {
            const scriptTag = document.createElement('script')
            scriptTag.setAttribute('src', '/static/js/wati.js')
            const div = document.getElementById("wati-div")
            console.log(scriptTag)
            div.appendChild(scriptTag);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ui/WatiWidget.vue